<script setup lang="ts">
/**
 * Advertência oficial do Ministério da Fazenda (Portaria SPA/MF 1.964/2026).
 *
 * Exibe SEMPRE a frase "aposta não é investimento" (sem rotação, a pedido).
 * As 3 frases oficiais seguem em texts.json (compliance.warnings) como
 * referência; aqui selecionamos só a de investimento. Renderizada como texto
 * discreto e legível, sem tarja/caixa — é elemento de ambiente/UI, não peça
 * publicitária.
 *
 * Reutilizável: usar em qualquer tela com conteúdo de apostas/bônus.
 */
import { texts } from '~/composables/useTexts';

const warnings = ((texts as Record<string, any>).compliance?.warnings ??
  []) as string[];

const phrase = ref<string>(
  warnings.find((w) => w.toLowerCase().includes('não é investimento')) ?? '',
);
</script>

<template>
  <p
    v-if="phrase"
    class="compliance-warning"
    role="note"
  >
    {{ phrase }}
  </p>
</template>

<style scoped lang="scss">
.compliance-warning {
  width: 100%;
  margin: 0;

  /* Texto discreto sobre o fundo escuro, sem tarja. Cinza legível (0.6) —
     a norma exige "legível" no ambiente, sem a régua de peça publicitária. */
  color: rgba(255, 255, 255, 0.6);

  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
}
</style>
